/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { PulseLoader } from 'react-spinners';
import Geocode from 'react-geocode';
import Select from 'react-select';
import { FaAngleRight } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { editStore } from '../../../../queries';

import Content from './styles';
import {
  Row,
  Label,
  Input,
  SelectLabel,
  Textarea,
  Button,
} from '../../../../assets/styles';

Geocode.setApiKey('AIzaSyCtkNjufsdpHK_v722l-8mG9sYZYAH5tyE');

class General extends Component {
  state = {
    storeName: '',
    cnpj: '',
    socialReason: '',
    phoneNumber: '',
    email: '',
    description: '',
    address: {
      lat: '',
      lng: '',
      cep: '',
      logradouro: '',
      number: '',
      bairro: '',
      cidade: '',
      uf: '',
    },
  };

  componentDidMount = () => {
    this.setState({
      storeName: this.props.store.name,
      cnpj: this.props.store.cnpj,
      socialReason: this.props.store.socialReason,
      phoneNumber: this.props.store.phoneNumber,
      email: this.props.store.email,
      description: this.props.store.description,
      address: this.props.store.address,
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      storeName,
      cnpj,
      socialReason,
      phoneNumber,
      email,
      description,
      address,
      storeNameError,
      emailError,
      phoneNumberError,
      descriptionError,
      cepError,
      numberError,
    } = this.state;

    if (
      !storeNameError
      && !emailError
      && !phoneNumberError
      && !descriptionError
      && !cepError
      && !numberError
    ) {
      this.setState({ loading: true });

      const data = {
        name: storeName,
        cnpj,
        socialReason,
        phoneNumber,
        email,
        description,
        address,
      };

      this.props
        .editStore({
          variables: {
            storeId: this.props.store.id,
            data,
          },
        })
        .then(async () => {
          this.setState({ loading: false });

          this.props.saveStore({ name: storeName });

          this.props.handleChangeState(data);

          this.props.alert.success('Informações salvas com sucesso');
        });
    }
  }

  validateInputs = () => {
    const {
      storeName,
      email,
      phoneNumber,
      description,
      address,
    } = this.state;

    this.setState({
      storeNameError: false,
      emailError: false,
      phoneNumberError: false,
      descriptionError: false,
      numberError: false,
    });

    const storeReg = /^[^\s][A-zÀ-ÿ0-9]*((-|\s)*[_A-zÀ-ÿ0-9])*$/;
    if (!storeReg.test(storeName)) this.setState({ storeNameError: true });

    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });

    const phoneReg = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/;
    if (!phoneReg.test(phoneNumber) || /_/i.test(phoneNumber)) this.setState({ phoneNumberError: true });

    if (description.length === 0) this.setState({ descriptionError: true });

    if (address.cep.length !== 9) {
      this.setState({ cepError: true });
      this.setState({ logradouroError: true });
      this.setState({ bairroError: true });
      this.setState({ cidadeError: true });
      this.setState({ ufError: true });
    }

    if (address.number.length === 0) this.setState({ numberError: true });
    if (address.logradouro.length === 0) this.setState({ logradouroError: true });
    if (address.bairro.length === 0) this.setState({ bairroError: true });
    if (address.cidade.length === 0) this.setState({ cidadeError: true });
    if (address.uf.length === 0) this.setState({ ufError: true });
  }

  validateCEP = async (cepCode) => {
    this.setState({
      address: {
        lat: '',
        lng: '',
        cep: cepCode,
        logradouro: 'Buscando...',
        number: '',
        bairro: 'Buscando...',
        cidade: 'Buscando...',
        uf: 'Buscando...',
      },
      cepError: false,
      logradouroError: false,
      numberError: false,
      bairroError: false,
      cidadeError: false,
      ufError: false,
    });

    if (cepCode.length === 9) {
      const response = await fetch(`https://viacep.com.br/ws/${cepCode}/json/`);
      const responseJson = await response.json();

      if ('erro' in responseJson) {
        this.setState({
          address: {
            lat: '',
            lng: '',
            cep: cepCode,
            logradouro: '',
            number: '',
            bairro: '',
            cidade: '',
            uf: '',
          },
          cepError: true,
        });
      } else {
        const {
          cep, logradouro, bairro, localidade, uf,
        } = responseJson;

        await Geocode.fromAddress(cep.replace('-', '')).then((res) => {
          const { lat, lng } = res.results[0].geometry.location;

          this.setState({
            address: {
              lat,
              lng,
              cep,
              logradouro,
              number: '',
              bairro,
              cidade: localidade,
              uf,
            },
          });
        });
      }
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleInputAddressChange = (e) => {
    this.setState({
      address: {
        ...this.state.address,
        [e.target.name]: e.target.value,
      },
    });

    if (e.target.name === 'cep') this.validateCEP(e.target.value);
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      storeName,
      cnpj,
      socialReason,
      phoneNumber,
      email,
      description,
      address,
      storeNameFocus,
      storeNameError,
      // cnpjFocus,
      // cnpjError,
      // socialReasonFocus,
      // socialReasonError,
      phoneNumberFocus,
      phoneNumberError,
      emailFocus,
      emailError,
      descriptionError,
      descriptionFocus,
      cepFocus,
      cepError,
      // logradouroFocus,
      logradouroError,
      numberFocus,
      numberError,
      // bairroFocus,
      bairroError,
      // cidadeFocus,
      cidadeError,
      // ufFocus,
      ufError,
    } = this.state;

    return (
      <Content>
        <h2>Dados da loja</h2>
        <Row>
          <div className="row-1">
            <Label>
              <p className="fieldName">Nome</p>
              <Input
                type="text"
                name="storeName"
                value={storeName}
                error={storeNameError}
                onFocusInput={storeNameFocus}
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('storeNameFocus')}
                onBlur={() => this.onBlur('storeNameFocus')}
              />
            </Label>
          </div>
          <div className="row-2">
            <Label>
              <p className="fieldName">CNPJ</p>
              <Input
                readOnly
                type="text"
                name="cnpj"
                value={cnpj}
                // error={cnpjError}
                // onFocusInput={cnpjFocus}
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('cnpjFocus')}
                onBlur={() => this.onBlur('cnpjFocus')}
              />
            </Label>
            <Label>
              <p className="fieldName">Razão Social</p>
              <Input
                readOnly
                type="text"
                name="socialReason"
                value={socialReason}
                // error={socialReasonError}
                // onFocusInput={socialReasonFocus}
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('socialReasonFocus')}
                onBlur={() => this.onBlur('socialReasonFocus')}
              />
            </Label>
          </div>
          <div className="row-2">
            <Label>
              <p className="fieldName">Telefone</p>
              <InputMask
                mask="(99) 9999-9999"
                maskChar={null}
                value={phoneNumber}
                onChange={this.handleInputChange}
                onFocusInput={phoneNumberFocus}
                onFocus={() => this.onFocus('phoneNumberFocus')}
                onBlur={() => this.onBlur('phoneNumberFocus')}
              >
                {inputProps => (
                  <Input
                    {...inputProps}
                    type="tel"
                    name="phoneNumber"
                    error={phoneNumberError}
                  />
                )}
              </InputMask>
            </Label>
            <Label>
              <p className="fieldName">E-mail</p>
              <Input
                type="email"
                name="email"
                value={email}
                error={emailError}
                onFocusInput={emailFocus}
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('emailFocus')}
                onBlur={() => this.onBlur('emailFocus')}
              />
            </Label>
          </div>
          <Label>
            <p className="fieldName">Descrição</p>
            <Textarea
              name="description"
              maxLength="300"
              value={description}
              error={descriptionError}
              onFocusInput={descriptionFocus}
              onChange={this.handleInputChange}
              onFocus={() => this.onFocus('descriptionFocus')}
              onBlur={() => this.onBlur('descriptionFocus')}
            />
          </Label>
          <h2>Endereço</h2>
          <div className="row-1">
            <Label>
              <p className="fieldName">CEP</p>
              <InputMask
                mask="99999-999"
                maskChar={null}
                value={address.cep}
                onChange={this.handleInputAddressChange}
                onFocusInput={cepFocus}
                onFocus={() => this.onFocus('cepFocus')}
                onBlur={() => this.onBlur('cepFocus')}
              >
                {inputProps => (
                  <Input
                    {...inputProps}
                    type="text"
                    name="cep"
                    error={cepError}
                  />
                )}
              </InputMask>
            </Label>
          </div>
          <div className="row-2">
            <Label>
              <p className="fieldName">Rua</p>
              <Input
                readOnly
                type="text"
                name="logradouro"
                value={address.logradouro}
                error={logradouroError}
                // onFocusInput={logradouroFocus}
                onChange={this.handleInputAddressChange}
                onFocus={() => this.onFocus('logradouroFocus')}
                onBlur={() => this.onBlur('logradouroFocus')}
              />
            </Label>
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Número</p>
                  <InputMask
                    mask="99999"
                    maskChar={null}
                    value={address.number}
                    error={numberError}
                    onFocusInput={numberFocus}
                    onChange={this.handleInputAddressChange}
                    onFocus={() => this.onFocus('numberFocus')}
                    onBlur={() => this.onBlur('numberFocus')}
                  >
                    {inputProps => (
                      <Input
                        size="10"
                        type="text"
                        name="number"
                        {...inputProps}
                      />
                    )}
                  </InputMask>
                </Label>
                <Label style={{ marginBottom: 0 }} />
              </div>
            </Label>
          </div>
          <div className="row-2">
            <Label>
              <p className="fieldName">Bairro</p>
              <Input
                readOnly
                type="text"
                name="bairro"
                value={address.bairro}
                error={bairroError}
                // onFocusInput={bairroFocus}
                onChange={this.handleInputAddressChange}
                onFocus={() => this.onFocus('bairroFocus')}
                onBlur={() => this.onBlur('bairroFocus')}
              />
            </Label>
            <Label style={{ marginBottom: 0 }}>
              <div className="row-2-2">
                <Label>
                  <p className="fieldName">Cidade</p>
                  <SelectLabel error={cidadeError}>
                    <Select
                      className="input"
                      classNamePrefix="input"
                      placeholder={address.cidade || 'Selecione'}
                      isDisabled
                      isSearchable={false}
                      isClearable={false}
                    />
                  </SelectLabel>
                </Label>
                <Label>
                  <p className="fieldName">Estado</p>
                  <SelectLabel error={ufError}>
                    <Select
                      className="input"
                      classNamePrefix="input"
                      placeholder={address.uf || 'Selecione'}
                      isDisabled
                      isSearchable={false}
                      isClearable={false}
                    />
                  </SelectLabel>
                </Label>
              </div>
            </Label>
          </div>
          <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
            {!loading ? (
              <span>
                {'Salvar'}
                <FaAngleRight className="fa fa-angle-right" />
              </span>
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={loading}
                style={{ paddingLeft: '25px' }}
              />
            )}
          </Button>
        </Row>
      </Content>
    );
  }
}
export default compose(
  withAlert(),
  graphql(editStore, { name: 'editStore' }),
)(General);
